import { render, staticRenderFns } from "./Section1.vue?vue&type=template&id=7363493a&scoped=true"
import script from "./Section1.vue?vue&type=script&lang=js"
export * from "./Section1.vue?vue&type=script&lang=js"
import style0 from "./Section1.vue?vue&type=style&index=0&id=7363493a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363493a",
  null
  
)

export default component.exports